import { Check } from 'lucide-react';
import clsx from 'clsx';
import { ETAPES_DU_PARCOURS, type EtapeDuParcours } from './etapes';

/*
  L'indicateur des quatre étapes, numérotées comme les critères de la page
  des stages. Une étape passée se rouvre d'un clic ; une étape à venir ne
  s'atteint que par le bouton du bas, qui sait si elle est prête.
*/

export default function EtapesDuParcours({
  courante,
  onAller,
}: {
  courante: EtapeDuParcours;
  onAller: (e: EtapeDuParcours) => void;
}) {
  const index = ETAPES_DU_PARCOURS.findIndex((e) => e.cle === courante);
  return (
    <ol aria-label="Étapes de l’inscription" className="grid grid-cols-4 gap-1">
      {ETAPES_DU_PARCOURS.map((e, i) => {
        const faite = i < index;
        const active = i === index;
        return (
          <li key={e.cle} className="flex flex-col items-center" aria-current={active ? 'step' : undefined}>
            {faite ? (
              <button
                type="button"
                onClick={() => onAller(e.cle)}
                aria-label={`Étape ${i + 1}, ${e.titre} : y revenir`}
                className="flex h-11 w-11 items-center justify-center rounded-full"
              >
                <span className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-primary-600 bg-white text-primary-600">
                  <Check className="h-4 w-4" aria-hidden="true" />
                </span>
              </button>
            ) : (
              <span className="flex h-11 w-11 items-center justify-center">
                <span
                  className={clsx(
                    'flex h-8 w-8 items-center justify-center rounded-full text-sm font-extrabold',
                    active ? 'bg-primary-600 text-white' : 'border-2 border-gray-300 bg-white text-gray-500',
                  )}
                >
                  {i + 1}
                </span>
              </span>
            )}
            <span
              className={clsx(
                'text-xs',
                active ? 'font-extrabold text-primary-700' : faite ? 'text-gray-700' : 'text-gray-500',
              )}
            >
              {e.libelle}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
